import React, {Component} from 'react';
import TextField from 'material-ui/TextField';

import {Col, Row} from './Grid';
import {HeadlineH3} from './text/Headlines';
import Select from './Select';

const inputStyle = {
  maxWidth: 500,
  width: '100%',
};

export default class extends Component {
  filterMetas = metaType => {
    if (!this.props.metas || this.props.metas.length === 0) {
      return [];
    }
    const metas = this.props.metas.filter(meta => meta.metaType === metaType);
    if (!metas || metas.length === 0) {
      return [];
    }
    return metas.sort((a, b) => {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });
  };

  render() {
    return (
      <div>
        <Row />
        <HeadlineH3>Fenster</HeadlineH3>
        <Row>
          <Col size={0.33}>
            <TextField
              type="text"
              style={inputStyle}
              floatingLabelText="Laufende Nummer"
              value={this.props.serialNumber}
              onChange={(_, value) => {
                this.props.handleTextValueChange('serialNumber', value);
              }}
            />
          </Col>
          <Col size={0.33}>
            <TextField
              type="text"
              style={inputStyle}
              floatingLabelText="Prüfzeugnis"
              value={this.props.qualityReportNumber}
              onChange={(_, value) => {
                this.props.handleTextValueChange('qualityReportNumber', value);
              }}
            />
          </Col>
          <Col size={0.33} />
          <Col size={0.33}>
            <TextField
              type="text"
              fullWidth={false}
              style={inputStyle}
              floatingLabelText="Breite*"
              value={this.props.width}
              onChange={(_, value) => this.props.handleTextValueChange('width', value)}
            />
          </Col>
          <Col size={0.33}>
            <TextField
              type="text"
              fullWidth={false}
              style={inputStyle}
              floatingLabelText="Höhe*"
              value={this.props.height}
              onChange={(_, value) => this.props.handleTextValueChange('height', value)}
            />
          </Col>
          <Col size={0.33}>
            <TextField
              type="text"
              fullWidth={false}
              style={inputStyle}
              floatingLabelText="Gesamtfläche*"
              value={this.props.completeSurface}
              onChange={(_, value) => this.props.handleTextValueChange('completeSurface', value)}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('winType')}
              value={this.props.winType}
              showAdd={this.props.showAdd}
              metaType="winType"
              label="Konstruktion"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('winClass')}
              value={this.props.winClass}
              showAdd={this.props.showAdd}
              metaType="winClass"
              label="Klasse"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('variation')}
              value={this.props.variation}
              showAdd={this.props.showAdd}
              metaType="variation"
              label="Typ"
              onChange={this.props.handleChange}
            />
          </Col>
        </Row>
        <HeadlineH3>Leistungsmerkmale</HeadlineH3>
        <Row>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('uValueFrame')}
              value={this.props.uValueFrame}
              showAdd={this.props.showAdd}
              metaType="uValueFrame"
              label="U-Wert Rahmen"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('uValueGlass')}
              value={this.props.uValueGlass}
              showAdd={this.props.showAdd}
              metaType="uValueGlass"
              label="U-Wert Glas"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('windLoad')}
              value={this.props.windLoad}
              showAdd={this.props.showAdd}
              metaType="windLoad"
              label="Windlast"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('drivingRain')}
              value={this.props.drivingRain}
              showAdd={this.props.showAdd}
              metaType="drivingRain"
              label="Schlagregen"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('psiValue')}
              value={this.props.psiValue}
              showAdd={this.props.showAdd}
              metaType="psiValue"
              label="Abst.h. psi"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('airPermeable')}
              value={this.props.airPermeable}
              showAdd={this.props.showAdd}
              metaType="airPermeable"
              label="Luftdurchlässigkeit"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('operateForce')}
              value={this.props.operateForce}
              showAdd={this.props.showAdd}
              metaType="operateForce"
              label="Bedienkräfte"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('mechanicalStress')}
              value={this.props.mechanicalStress}
              showAdd={this.props.showAdd}
              metaType="mechanicalStress"
              label="Mechanische Beanspruchung"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('thermalInsulation')}
              value={this.props.thermalInsulation}
              showAdd={this.props.showAdd}
              metaType="thermalInsulation"
              label="Uw"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('soundInsulation')}
              value={this.props.soundInsulation}
              showAdd={this.props.showAdd}
              metaType="soundInsulation"
              label="dB"
              onChange={this.props.handleChange}
            />
          </Col>
        </Row>
        <HeadlineH3>Material</HeadlineH3>
        <Row>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('rainRackType')}
              value={this.props.rainRackType}
              showAdd={this.props.showAdd}
              metaType="rainRackType"
              label="Regenschiene"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('coatingType')}
              value={this.props.coatingType}
              showAdd={this.props.showAdd}
              metaType="coatingType"
              label="Beschlag"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('wingSeal')}
              value={this.props.wingSeal}
              showAdd={this.props.showAdd}
              metaType="wingSeal"
              label="Überschlagdichtung"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('foldSeal')}
              value={this.props.foldSeal}
              showAdd={this.props.showAdd}
              metaType="foldSeal"
              label="Falzdichtung"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('glassType')}
              value={this.props.glassType}
              showAdd={this.props.showAdd}
              metaType="glassType"
              label="Glastyp"
              onChange={this.props.handleChange}
            />
          </Col>
        </Row>
        <HeadlineH3>Hersteller</HeadlineH3>
        <Row>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('rainRackProd')}
              value={this.props.rainRackProd}
              showAdd={this.props.showAdd}
              metaType="rainRackProd"
              label="Regenschiene Hersteller"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('coatingProd')}
              value={this.props.coatingProd}
              showAdd={this.props.showAdd}
              metaType="coatingProd"
              label="Beschlag Hersteller"
              onChange={this.props.handleChange}
            />
          </Col>
          <Col size={0.33}>
            <Select
              data={this.filterMetas('sealProd')}
              value={this.props.sealProd}
              showAdd={this.props.showAdd}
              metaType="sealProd"
              label="Dichtungshersteller"
              onChange={this.props.handleChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WindowParams.js